import * as React from "react";

export const SecurityInfo: React.FC<{ variant?: "light" | "dark" }> = ({
  variant = "light",
}) => {
  return (
    <footer
      className={`flex flex-wrap lg:gap-10 justify-between items-center mt-11 w-full text-base font-semibold tracking-normal max-md:mt-10 max-md:max-w-full ${
        variant === "dark" ? "text-white" : "text-zinc-600"
      }`}
    >
      <p className="self-stretch my-auto text-left lg:text-center text-[14px] lg:text-[16px]">
        All projects secured by NDA & IP is your's
      </p>
      <p className="self-stretch my-auto  text-left lg:text-center text-[14px] lg:text-[16px]">
        100% Secure. Zero Spam.
      </p>
    </footer>
  );
};
